import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useGyerekek } from '../GyerekekContext';
import Leckek from './Leckek';
import Leckek911 from './Leckek911';
import Leckek1214 from './Leckek1214';
import Fogalmak from './Fogalmak';

const KOROSZTALYOK_LISTA = [
  { ertek: '6-8', cimke: '6–8 év' },
  { ertek: '9-11', cimke: '9–11 év' },
  { ertek: '12-14', cimke: '12–14 év' },
];

// Teszt/admin fiók: ezzel az email címmel bejelentkezve minden korosztály
// szabadon elérhető, gyerek-profiltól függetlenül.
const ADMIN_EMAIL = 'info.netokos@gmail.com';

// ============ ANIMÁLT HÁTTÉR ============
function AnimaltHatter() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);

    const alakzatok = Array.from({length: 25}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      meret: Math.random() * 60 + 20,
      vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4,
      szin: ['#1a73e8','#34a853','#9c27b0','#f9ab00','#00bcd4','#ea4335'][Math.floor(Math.random()*6)],
      alpha: Math.random() * 0.07 + 0.02,
      forgat: Math.random() * Math.PI * 2,
      forgSeb: (Math.random() - 0.5) * 0.01,
      tipus: Math.floor(Math.random() * 3),
    }));

    const rajzHaromszog = (x, y, m, szin, alpha, rot) => {
      ctx.save();
      ctx.translate(x, y); ctx.rotate(rot);
      ctx.beginPath();
      ctx.moveTo(0, -m); ctx.lineTo(m * 0.866, m * 0.5); ctx.lineTo(-m * 0.866, m * 0.5);
      ctx.closePath();
      ctx.fillStyle = szin;
      ctx.globalAlpha = alpha;
      ctx.fill();
      ctx.restore();
    };

    const rajzNegyzet = (x, y, m, szin, alpha, rot) => {
      ctx.save();
      ctx.translate(x, y); ctx.rotate(rot);
      ctx.beginPath();
      ctx.rect(-m/2, -m/2, m, m);
      ctx.fillStyle = szin;
      ctx.globalAlpha = alpha;
      ctx.fill();
      ctx.restore();
    };

    const rajzKor = (x, y, m, szin, alpha) => {
      ctx.beginPath();
      ctx.arc(x, y, m/2, 0, Math.PI * 2);
      ctx.fillStyle = szin;
      ctx.globalAlpha = alpha;
      ctx.fill();
    };

    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      alakzatok.forEach(a => {
        a.x += a.vx; a.y += a.vy; a.forgat += a.forgSeb;
        if (a.x < -a.meret) a.x = canvas.width + a.meret;
        if (a.x > canvas.width + a.meret) a.x = -a.meret;
        if (a.y < -a.meret) a.y = canvas.height + a.meret;
        if (a.y > canvas.height + a.meret) a.y = -a.meret;
        ctx.globalAlpha = 1;
        if (a.tipus === 0) rajzKor(a.x, a.y, a.meret, a.szin, a.alpha);
        else if (a.tipus === 1) rajzHaromszog(a.x, a.y, a.meret/2, a.szin, a.alpha, a.forgat);
        else rajzNegyzet(a.x, a.y, a.meret/2, a.szin, a.alpha, a.forgat);
      });
      ctx.globalAlpha = 1;
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}/>;
}

function Temakork({ felhasznalo }) {
  const [kivalasztott, setKivalasztott] = React.useState(null);
  const navigate = useNavigate();

  const { gyerekek, betoltve: gyerekBetoltve, gyerekekHelyiFrissitese } = useGyerekek();
  const [ujGyerekNev, setUjGyerekNev] = useState('');
  const [ujGyerekKor, setUjGyerekKor] = useState('6-8');
  const [gyerekMentes, setGyerekMentes] = useState(false);

  const aktivGyerek = gyerekek[0] || null;

  const gyerekHozzaadasa = async () => {
    if (!ujGyerekNev.trim() || !felhasznalo) return;
    setGyerekMentes(true);
    const ref = doc(db, 'felhasznalok', felhasznalo.uid);
    const ujGyerek = {
      id: crypto.randomUUID(),
      nev: ujGyerekNev.trim(),
      koroszaly: ujGyerekKor,
      xp: 0,
      letrehozva: new Date().toISOString(),
    };
    const ujLista = [...gyerekek, ujGyerek];
    await setDoc(ref, {
      email: felhasznalo.email,
      gyerekek: ujLista,
      hozzajarulasElfogadva: true,
      hozzajarulasDatuma: serverTimestamp(),
    }, { merge: true });
    gyerekekHelyiFrissitese(ujLista);
    setUjGyerekNev('');
    setGyerekMentes(false);
  };

  // A Fogalmak mindenkinek elérhető. A többi kártyát csak bejelentkezve,
  // gyerek-profillal, és csak a gyerek saját korosztályának megfelelően
  // lehet megnyitni. Az ADMIN_EMAIL fiók mindent elér, korlátozás nélkül.
  const adminMod = felhasznalo?.email === ADMIN_EMAIL;

  const kartyaKattintas = (id) => {
    if (id === 'fogalmak' || adminMod) { setKivalasztott(id); return; }
    if (!felhasznalo) { navigate('/belepes'); return; }
    if (!aktivGyerek) return;
    if (id !== aktivGyerek.koroszaly) return;
    setKivalasztott(id);
  };

if (kivalasztott === '6-8') return <div><button onClick={() => setKivalasztott(null)} style={{margin:'1rem',padding:'10px 22px',background:'#1a73e8',color:'white',border:'none',borderRadius:'50px',fontSize:'14px',fontWeight:'800',cursor:'pointer'}}>← Vissza a tanuláshoz</button><Leckek felhasznalo={felhasznalo}/></div>;
if (kivalasztott === '9-11') return <div><button onClick={() => setKivalasztott(null)} style={{margin:'1rem',padding:'10px 22px',background:'#0d7377',color:'white',border:'none',borderRadius:'50px',fontSize:'14px',fontWeight:'800',cursor:'pointer'}}>← Vissza a tanuláshoz</button><Leckek911 felhasznalo={felhasznalo}/></div>;
if (kivalasztott === '12-14') return <div><button onClick={() => setKivalasztott(null)} style={{margin:'1rem',padding:'10px 22px',background:'#9c27b0',color:'white',border:'none',borderRadius:'50px',fontSize:'14px',fontWeight:'800',cursor:'pointer'}}>← Vissza a tanuláshoz</button><Leckek1214 felhasznalo={felhasznalo}/></div>;
if (kivalasztott === 'fogalmak') return <div><button onClick={() => setKivalasztott(null)} style={{margin:'1rem',padding:'10px 22px',background:'#7c3aed',color:'white',border:'none',borderRadius:'50px',fontSize:'14px',fontWeight:'800',cursor:'pointer'}}>← Vissza a tanuláshoz</button><Fogalmak/></div>;
 const korosztalyok = [
  {
    id: '6-8',
    kor: '6–8 év',
    cim: 'Cyber Robi kalandjai',
    kep: '/cyber_robi.png',
    leiras:
      'Ismerkedj meg az internet világával Cyber Robi segítségével! Játékos feladatokkal, mesékkel és izgalmas kihívásokkal tanulhatod meg, hogyan internetezz biztonságosan.',
    szin: '#1a73e8',
    masodszin: '#4fc3f7',
    haatter: 'linear-gradient(135deg, #e3f2fd, #f3e5f5)',
    border: '#1a73e8',
    leckek: 8,
    xp: '+30 XP/lecke',
    badge: '👶 Kezdő',
    jellemzok: [
      '🖼️ Képes feladatok',
      '🎮 Mini játékok',
      '🎭 Szerepjáték',
      '🎨 Kreatív kihívások',
    ],
  },

  {
    id: '9-11',
    kor: '9–11 év',
    cim: 'Agent X küldetései',
    kep: '/agent x.png',
    leiras:
      'Lépj be Agent X csapatába! Oldj meg nyomozós küldetéseket és tanuld meg a biztonságos internetezés szabályait.',
    szin: '#0d7377',
    masodszin: '#00bcd4',
    haatter: 'linear-gradient(135deg, #e0f7fa, #e8f5e9)',
    border: '#0d7377',
    leckek: 10,
    xp: '+50 XP/lecke',
    badge: '⚡ Ügynök',
    jellemzok: [
      '🕵️ Nyomozós küldetések',
      '💬 Chat-szimuláció',
      '🔐 Jelszó kihívások',
      '🧩 Logikai feladatok',
    ],
  },

  {
    id: '12-14',
    kor: '12–14 év',
    cim: 'Nova Akadémia',
    kep: '/nova.png',
    leiras:
      'Nova segítségével megismerheted az AI-t, a digitális lábnyomot és a modern kibervédelem világát.',
    szin: '#9c27b0',
    masodszin: '#ce93d8',
    haatter: 'linear-gradient(135deg, #f3e5f5, #ede7f6)',
    border: '#9c27b0',
    leckek: 10,
    xp: '+60 XP/lecke',
    badge: '🔥 Elite',
    jellemzok: [
      '🤖 AI kihívások',
      '🧠 Valós szituációk',
      '🔎 Digitális nyomozás',
      '🌐 Online stratégia',
    ],

    
  },
  {
    id: 'fogalmak',
    kor: 'Minden korosztály',
    cim: 'Fogalmak és tudnivalók',
    kep: null,
    emoji: '📖',
    leiras: 'Fogalomtár, lépéses útmutatók, netikett szabályok és biztonsági tippek - mindhárom korosztálynak, szűrhető formában.',
    szin: '#7c3aed',
    masodszin: '#a78bfa',
    haatter: 'linear-gradient(135deg, #f3e5f5, #ede7f6)',
    border: '#7c3aed',
    leckek: '22+',
    xp: 'Ingyenes',
    badge: '📚 Tudástár',
    jellemzok: [
      '📖 Fogalomtár',
      '🛠️ Lépéses útmutatók',
      '🤝 Netikett szabályok',
      '🔒 Biztonsági tippek',
    ],
  },
];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
        .temakork-wrapper * { font-family: 'Nunito', sans-serif !important; }
        .temakork {
          min-height: calc(100vh - 70px);
          background: var(--bg-page);
          padding: 4rem 2rem;
          box-sizing: border-box;
          position: relative;
          overflow: hidden;
        }
        .temakork-inner { position: relative; z-index: 1; }
        .temakork-cim-resz { text-align: center; margin-bottom: 3rem; }
        .temakork-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: var(--bg-card-transparent); backdrop-filter: blur(10px);
          border: 2px solid var(--border-color-strong); border-radius: 50px;
          padding: 8px 20px; font-size: 14px; font-weight: 700; color: var(--text-primary); margin-bottom: 1rem;
          box-shadow: 0 4px 16px rgba(0,0,0,0.06);
        }
        .temakork-fo-cim { font-size: 48px; font-weight: 900; color: var(--text-primary); margin-bottom: 1rem; }
        .temakork-fo-cim span {
          background: linear-gradient(135deg, #1a73e8, #9c27b0);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
        }
        .temakork-alcim { font-size: 18px; color: var(--text-secondary); max-width: 600px; margin: 0 auto; line-height: 1.7; }
        .temakork-grid {
          max-width: 1200px; margin: 0 auto;
          display: grid; grid-template-columns: repeat(2, 1fr); gap: 2rem;
        }
        .temakork-kartya {
          background: var(--bg-card-transparent); backdrop-filter: blur(10px);
          border-radius: 28px; overflow: hidden;
          box-shadow: 0 8px 32px rgba(0,0,0,0.08); border: 3px solid transparent;
          transition: all 0.3s cubic-bezier(0.34,1.56,0.64,1);
          cursor: pointer; display: flex; flex-direction: column;
          position: relative;
        }
        .temakork-kartya:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 24px 64px rgba(0,0,0,0.15);
        }
        .temakork-kartya-zar {
          position: absolute; top: 16px; left: 16px; z-index: 2;
          display: flex; align-items: center; gap: 6px;
          background: rgba(26,26,46,0.85); color: white;
          padding: 6px 14px; border-radius: 50px;
          font-size: 12px; font-weight: 800;
        }
        .temakork-kartya-fejlec { padding: 2rem; display: flex; flex-direction: column; gap: 1rem; flex: 1; }
        .temakork-kartya-ikon-sor { display: flex; align-items: center; justify-content: space-between; }
      .temakork-kartya-ikon {
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ikonUgrik 3s ease-in-out infinite;
}

.temakork-kartya-ikon img {
  width: 220px;
  height: 220px;
  object-fit: contain;
  filter: drop-shadow(0 8px 12px rgba(0,0,0,0.15));
}
        @keyframes ikonUgrik { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
        .temakork-kartya-badge { font-size: 13px; font-weight: 800; padding: 6px 14px; border-radius: 50px; border: 2px solid; }
        .temakork-kartya-kor { font-size: 13px; font-weight: 800; color: var(--text-muted); letter-spacing: 1px; text-transform: uppercase; }
        .temakork-kartya-cim { font-size: 24px; font-weight: 900; color: var(--text-primary); line-height: 1.2; }
        .temakork-kartya-leiras { font-size: 15px; color: var(--text-secondary); line-height: 1.6; font-weight: 600; }
        .temakork-kartya-jellemzok { display: flex; flex-wrap: wrap; gap: 8px; }
        .temakork-kartya-jellemzo {
          font-size: 12px; font-weight: 700; padding: 5px 12px; border-radius: 50px;
          background: rgba(255,255,255,0.8); color: #555; border: 1px solid #e9ecef;
        }
        .temakork-kartya-also {
          padding: 1.5rem 2rem; border-top: 2px solid rgba(0,0,0,0.05);
          display: flex; align-items: center; justify-content: space-between; gap: 1rem;
        }
        .temakork-kartya-info { display: flex; gap: 1.5rem; }
        .temakork-kartya-info-elem { text-align: center; }
        .temakork-kartya-info-szam { font-size: 22px; font-weight: 900; }
        .temakork-kartya-info-felirat { font-size: 11px; color: var(--text-muted); font-weight: 700; }
        .temakork-kartya-gomb {
          padding: 12px 22px; border: none; border-radius: 50px;
          font-size: 14px; font-weight: 800; color: white; cursor: pointer;
          transition: all 0.25s cubic-bezier(0.34,1.56,0.64,1);
          box-shadow: 0 4px 16px rgba(0,0,0,0.2); white-space: nowrap;
          font-family: 'Nunito', sans-serif !important;
        }
        .temakork-kartya-gomb:hover { transform: translateY(-3px) scale(1.05); box-shadow: 0 8px 24px rgba(0,0,0,0.3); }
        @media (max-width: 1024px) {
          .temakork-grid { grid-template-columns: 1fr; max-width: 500px; }
          .temakork-fo-cim { font-size: 36px; }
        }
        @media (max-width: 600px) {
          .temakork { padding: 2rem 1rem; }
          .temakork-fo-cim { font-size: 28px; }
          .temakork-alcim { font-size: 16px; }
          .temakork-kartya-cim { font-size: 20px; }
          .temakork-kartya-also { flex-direction: column; align-items: flex-start; }
          .temakork-kartya-gomb { width: 100%; text-align: center; }
        }
      `}</style>

      <div className="temakork-wrapper">
        <div className="temakork">
          <AnimaltHatter/>
          <div className="temakork-inner">
            <div className="temakork-cim-resz">
              <div className="temakork-badge"><span>📚</span>Válassz korosztályt és kezdj el tanulni!</div>
              <h1 className="temakork-fo-cim">Melyik <span>kaland</span> vár rád?</h1>
              <p className="temakork-alcim">Három különböző korosztálynak készítettük el a leckéket. Válaszd ki a korodnak megfelelő szintet! 🎯</p>
            </div>

            {felhasznalo && gyerekBetoltve && !aktivGyerek && !adminMod && (
              <div style={{
                maxWidth: '1200px', margin: '0 auto 2rem', background: 'var(--bg-card-transparent)',
                backdropFilter: 'blur(10px)', borderRadius: '24px', padding: '2rem',
                border: '3px solid #1a73e8', boxShadow: '0 8px 32px var(--shadow-color)',
              }}>
                <div style={{fontSize: '18px', fontWeight: 900, color: 'var(--text-primary)', marginBottom: '0.5rem'}}>
                  👶 Add meg gyermeked adatait a folytatáshoz!
                </div>
                <p style={{fontSize: '14px', color: 'var(--text-secondary)', marginBottom: '1.25rem'}}>
                  Ez alapján tudjuk megmutatni neki a korosztályának megfelelő tananyagot.
                </p>
                <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end'}}>
                  <div style={{flex: '1 1 200px'}}>
                    <label style={{fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', display: 'block', marginBottom: '6px'}}>Gyermeked neve</label>
                    <input type="text" value={ujGyerekNev} onChange={e => setUjGyerekNev(e.target.value)}
                      placeholder="pl. Kata"
                      style={{width: '100%', padding: '12px 14px', borderRadius: '10px', border: '1.5px solid var(--border-color-strong)', fontSize: '15px', outline: 'none', boxSizing: 'border-box', background: 'var(--bg-input)', color: 'var(--text-primary)'}} />
                  </div>
                  <div style={{flex: '1 1 260px'}}>
                    <label style={{fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', display: 'block', marginBottom: '6px'}}>Korosztály</label>
                    <div style={{display: 'flex', gap: '8px'}}>
                      {KOROSZTALYOK_LISTA.map(k => (
                        <button key={k.ertek} type="button" onClick={() => setUjGyerekKor(k.ertek)}
                          style={{
                            flex: 1, padding: '10px 8px', borderRadius: '10px', fontSize: '13px', fontWeight: 700, cursor: 'pointer',
                            border: ujGyerekKor === k.ertek ? '2px solid #1a73e8' : '1.5px solid var(--border-color-strong)',
                            background: ujGyerekKor === k.ertek ? '#e3f2fd' : 'var(--bg-input)',
                            color: ujGyerekKor === k.ertek ? '#1a73e8' : 'var(--text-secondary)',
                          }}>
                          {k.cimke}
                        </button>
                      ))}
                    </div>
                  </div>
                  <button onClick={gyerekHozzaadasa} disabled={gyerekMentes || !ujGyerekNev.trim()}
                    style={{
                      padding: '13px 28px', borderRadius: '50px', border: 'none', fontSize: '15px', fontWeight: 800,
                      color: 'white', cursor: 'pointer', background: 'linear-gradient(135deg, #1a73e8, #4fc3f7)',
                      whiteSpace: 'nowrap', opacity: gyerekMentes || !ujGyerekNev.trim() ? 0.6 : 1,
                    }}>
                    {gyerekMentes ? '⏳ Mentés...' : 'Mentés ✅'}
                  </button>
                </div>
              </div>
            )}

            <div className="temakork-grid">
              {korosztalyok.map((k, idx) => {
                const zarolva = k.id !== 'fogalmak' && !adminMod && (!felhasznalo || !aktivGyerek || k.id !== aktivGyerek.koroszaly);
                const zarSzoveg = !felhasznalo
                  ? '🔒 Bejelentkezés szükséges'
                  : !aktivGyerek
                    ? '🔒 Add meg gyermeked adatait'
                    : '🔒 Nem a te korosztályod';
                return (
                <div key={k.id} className="temakork-kartya" style={{borderColor: k.border, opacity: zarolva ? 0.7 : 1}} onClick={() => kartyaKattintas(k.id)}>
                  {zarolva && <div className="temakork-kartya-zar">{zarSzoveg}</div>}
                  <div className="temakork-kartya-fejlec" style={{background: k.haatter}}>
                    <div className="temakork-kartya-ikon-sor">
                    <div 
  className="temakork-kartya-ikon"
  style={{
    animationDelay: `${idx * 0.5}s`
  }}
>
  {k.kep ? (
    <img 
      src={k.kep}
      alt={k.cim}
    />
  ) : (
    <span style={{fontSize: '90px', lineHeight: 1}}>{k.emoji}</span>
  )}
</div>
                      <div className="temakork-kartya-badge" style={{color: k.szin, borderColor: k.szin, background: 'white'}}>{k.badge}</div>
                    </div>
                    <div className="temakork-kartya-kor">{k.kor}</div>
                    <div className="temakork-kartya-cim">{k.cim}</div>
                    <div className="temakork-kartya-leiras">{k.leiras}</div>
                    <div className="temakork-kartya-jellemzok">
                      {k.jellemzok.map((j, i) => <div key={i} className="temakork-kartya-jellemzo">{j}</div>)}
                    </div>
                  </div>
                  <div className="temakork-kartya-also">
                    <div className="temakork-kartya-info">
                      <div className="temakork-kartya-info-elem">
                        <div className="temakork-kartya-info-szam" style={{color: k.szin}}>{k.leckek}</div>
                        <div className="temakork-kartya-info-felirat">Lecke</div>
                      </div>
                      <div className="temakork-kartya-info-elem">
                        <div className="temakork-kartya-info-szam" style={{color: k.szin}}>{k.xp}</div>
                        <div className="temakork-kartya-info-felirat">Jutalom</div>
                      </div>
                    </div>
                    <button className="temakork-kartya-gomb" style={{background: `linear-gradient(135deg, ${k.szin}, ${k.masodszin})`}}>
                      {zarolva ? '🔒 Zárolva' : 'Kezdjük! 🚀'}
                    </button>
                  </div>
                </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Temakork;